"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[2914],{

/***/ 62914:
/***/ ((module) => {

module.exports = JSON.parse('{"deleted":"Deleted","noteOrTodoIsDeleted":"The note / To-Do item has been deleted","saved":"Saved","statusChanged":"Status changed"}');

/***/ })

}]);